import { environment } from '@/assets/environment';
import { IErrorResponse } from '@/models/errors/error-response.model';
import { BatteriesHelperData } from '@/models/store/batteries/bat-helper-data.model';
import { IBatteriesState } from '@/models/store/batteries/batteries-state.model';
import { IBattery } from '@/models/store/batteries/battery.model';
import { IBatteriesFilter } from '@/models/store/filter-data/batteries-filter.model';
import { isEqual } from 'lodash';
import { Module } from 'vuex';

export const batteriesModule: Module<IBatteriesState, unknown> = {
    state: {
        batteries: [],
        batteriesHelperData: { brands: [], volumes: [], startingCurrents: [] },
    },

    actions: {
        fetchBatteries: async (
            { commit },
            payload: { pageNumber: number; count: number; batteriesFilter: IBatteriesFilter },
        ): Promise<void> => {
            const params = new URLSearchParams();
            params.append('pageNumber', `${payload.pageNumber}`);
            params.append('count', `${payload.count}`);
            if (payload.batteriesFilter.typeName)
                params.append('typeName', payload.batteriesFilter.typeName);
            if (payload.batteriesFilter.brand)
                params.append('brand', payload.batteriesFilter.brand);
            if (payload.batteriesFilter.volume)
                params.append('volume', payload.batteriesFilter.volume);
            if (payload.batteriesFilter.startingCurrent)
                params.append('startingCurrent', payload.batteriesFilter.startingCurrent);
            if (isEqual(typeof payload.batteriesFilter.type, 'boolean'))
                params.append('type', String(payload.batteriesFilter.type));

            const response = await fetch(`${environment.baseUrl}/api/batteries?` + params, {
                method: 'get',
                headers: {
                    'x-app': 'secret_admin',
                    'Content-type': 'application/json',
                },
            });

            if (!response.ok) {
                const errorObject: IErrorResponse = await response.json();
                commit('setSnackbarState', {
                    status: true,
                    text: errorObject.error,
                    isError: true,
                });
                return;
            }

            const batteriesData = await response.json();
            commit('setPaginationLength', batteriesData.length);
            commit('setBatteries', batteriesData.data);
        },

        fetchBatteriesHelperData: async ({ commit }) => {
            const response = await fetch(`${environment.baseUrl}/api/helper-batteries`, {
                method: 'get',
                headers: {
                    'x-app': 'secret_admin',
                    'Content-type': 'application/json',
                },
            });

            if (!response.ok) {
                const errorObject: IErrorResponse = await response.json();
                commit('setSnackbarState', {
                    status: true,
                    text: errorObject.error,
                    isError: true,
                });
                return;
            }

            const filterData = (await response.json()).data;
            commit('setBatteriesHelperData', filterData);
        },
    },

    mutations: {
        setBatteries: (store, payload: IBattery[]): void => {
            store.batteries = [...payload];
        },
        setBatteriesHelperData: (store, payload: BatteriesHelperData): void => {
            store.batteriesHelperData = { ...payload };
        },
    },

    getters: {
        getBatteries: (store) => store.batteries,
        getBatteriesHelperData: (store) => store.batteriesHelperData,
    },
};
